import { STORE_KEY_ID_LIST, notifyParent, storeGet } from 'mailup-react-helpers'

import {
  type FicConnectionStatus,
  beFattureinCloudApiGetListConfiguration,
  beFattureinCloudApiImportClients,
} from 'Api/beFattureInCloudApi'

export const fetchConnectionStatus = async (): Promise<FicConnectionStatus> => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const listStatus = await beFattureinCloudApiGetListConfiguration(idList)

  return listStatus !== null && listStatus !== undefined
    ? listStatus.Status
    : 'DISCONNECTED'
}

export const importClients = async (): Promise<
  [FicConnectionStatus, string]
> => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const { Status, FileName } = await beFattureinCloudApiImportClients(idList)

  const i = FileName.lastIndexOf('/')

  return [Status, i === -1 ? FileName : FileName.substring(i + 1)]
}

export const handleImport = (fileName: string): void => {
  notifyParent('redirectMainFrame', [
    `form_import.aspx?=back&file=${fileName}&fic=true`,
  ])
}
